module.exports = __webpack_public_path__ + "media/assets/images/flags/lb-bdfdc3be7d4ca431b13022d7b937d63b.svg";